import API from '../api'

export const WorksheetsUrl = '/web/budgets/worksheet'

export const setAppliedYear = async (budgetWorksheetId: string, year: number): Promise<void> => {
  return (await API.post(`${WorksheetsUrl}/${budgetWorksheetId}/apply/${year}`)).data
}
